<template>
    <div class="room__rm-files rm-files">
        <h2 class="rm-files__title r-title">Отправленные файлы</h2>
        <div class="rm-files__content">
            <attachments></attachments>
        </div>
        <attachment-upload></attachment-upload>
    </div>
</template>

<script>
    import Attachments from './Attachments.vue';
    import AttachmentUpload from './AttachmentUpload.vue';

    export default {
        name: 'AttachmentScreen',
        components: {
            Attachments,
            AttachmentUpload,
        },
    }
</script>
